var React = require('react');

function Cocktail (props) {
    return React.createElement("svg",props,[React.createElement("polygon",{"points":"20.54 25.5 99.79 25.5 60.04 83.5 20.54 25.5","key":0}),React.createElement("line",{"x1":"60.17","y1":"83.5","x2":"60.17","y2":"118","key":1}),React.createElement("line",{"x1":"46.29","y1":"117.75","x2":"74.04","y2":"117.75","key":2}),React.createElement("polyline",{"points":"20.75 9.5 45 16 54.75 44.75","key":3}),React.createElement("line",{"x1":"35.75","y1":"46.5","x2":"84.75","y2":"46.5","key":4}),React.createElement("path",{"d":"M88.31,24.63a12.37,12.37,0,1,1,5.4,11.51","key":5})]);
}

Cocktail.defaultProps = {"className":"svg-cocktail","viewBox":"0 0 128 128","stroke":"#000000","fill":"none"};

module.exports = Cocktail;

Cocktail.default = Cocktail;
